import apiClient from './apiClient';

export const secretService = {
  getSecrets: (spaceId) => {
    return apiClient.get(`/spaces/${spaceId}/secrets`);
  },

  getSecret: (id) => {
    return apiClient.get(`/secrets/${id}`);
  },

  createSecret: (spaceId, data) => {
    return apiClient.post(`/spaces/${spaceId}/secrets`, data);
  },

  updateSecret: (id, data) => {
    return apiClient.put(`/secrets/${id}`, data);
  },

  deleteSecret: (id) => {
    return apiClient.delete(`/secrets/${id}`);
  },

  searchSecrets: (params) => {
    return apiClient.get('/secrets/search', { params });
  },

  getDecryptedPassword: (id) => {
    return apiClient.get(`/secrets/${id}/password`);
  },

  getDecryptedSecretKey: (id) => {
    return apiClient.get(`/secrets/${id}/secret-key`);
  },

  assignLabels: (id, labelIds) => {
    return apiClient.post(`/secrets/${id}/labels`, { label_ids: labelIds });
  },

  removeLabel: (id, labelId) => {
    return apiClient.delete(`/secrets/${id}/labels/${labelId}`);
  },

  getSecretsByLabel: (labelId) => {
    return apiClient.get(`/labels/${labelId}/secrets`);
  },

  getLabel: (id) => {
    return apiClient.get(`/labels/${id}`);
  },
};
